import { Box, Typography, styled } from '@mui/material';

interface MTEHeaderProps {
  title: string;
  subtitle?: string;
}

export const MTEHeader = ({ title, subtitle }: MTEHeaderProps) => {
  return (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        mt={1}
        mb={3}
      >
        <Title variant="h1">{title}</Title>
        <Typography>{subtitle}</Typography>
      </Box>
  );
};

const Title = styled(Typography)(({ theme }) => {
  return {
    color: theme.palette.primary.main,

    fontSize: theme.config.textSizes.paragon,
  };
});
